import { Pipe, PipeTransform } from '@angular/core';
import { ICard } from '../services/credit-cards.service';

@Pipe({
  name: 'creditCardName'
})
export class CreditCardNamePipe implements PipeTransform {
  transform(card: ICard): string {
    return `xxxx xxxx xxxx ${card.suffix.substr(card.suffix.length - 4)} - ${
      card.cardType
    } - ${card.name}`;
  }
}
